<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import { MAILJET_STATUS_CONFIG } from "../helpers/constants";
import DownloadOptionsModal from "@/components/commons/DownloadOptionsModal.vue";
import { runExcelUpload } from "../upload/flow";
const XLSX = require("xlsx");

export default {
  components: {
    DownloadOptionsModal,
  },
  template: `
    <div>
      <div class='is-flex is-align-items-center' :class='isMovil ? "is-justify-center is-flex-wrap-wrap" : "" '>
        <!-- Chip de recordatorio 50% -->
        <div v-if="showReminderChip" class="reminder-chip" :class="reminder50Sent ? 'is-sent' : 'is-pending'">
          <i class="material-icons">{{ reminder50Sent ? 'mark_email_read' : 'schedule_send' }}</i>
          <span v-if="reminder50Sent">
            Recordatorio enviado: {{ formatDate(proceso.reminder50SentAt) }}
          </span>
          <span v-else>
            Recordatorio automático al superar 50%
          </span>
          <button
            v-if="reminder50Sent"
            class="resend-btn"
            v-on:click="resendReminder50"
            v-tooltip="'Reenviar recordatorio'"
          >
            <i class="material-icons">refresh</i>
          </button>
        </div>
        <button class="button is-link is-outlined" v-on:click='activeMenu'>Menú</button>
        <button class="button is-link" style="margin-left: 5px" v-on:click="isDownloadModalActive = true">
        <span v-tooltip="'Descargar encuestados'" class="icon">
          <i class="material-icons">cloud_download</i>
        </span>
        </button>
        <button class="button is-link" style="margin-left: 5px" v-on:click="sendAllEmails()">
        <span v-tooltip="'Enviar correo a todos los pendientes'" class="icon">
          <i class="material-icons">email</i>
        </span>
        </button>
        <button class="button" style="margin-left: 5px" :class="proceso.survey ? 'is-dark' : 'is-grey'" v-on:click="switchStatus()">
          <span v-tooltip="(proceso.survey ? 'Deshabilitar' : 'Habilitar') + ' encuestas'" class="icon">
            <i class="material-icons">{{ proceso.survey ? 'toggle_on' : 'toggle_off' }}</i>
          </span>
    </button>
      </div>
      <nav id='menuFilter' v-if='active' class="panel">
        <div class="panel-heading">
          <div class='is-size-6 is-flex'>
            <!-- Title -->
          </div>
          <button class="delete" aria-label="delete" v-on:click='activeMenu'></button>
        </div>
        <div class='panel-body'>
          <p class="panel-tabs has-text-centered">
            <span class='has-text-weight-bold'>Encuestas</span>
          </p>
          <a class="panel-block file-label" :class='elements[0].active ? "is-active" : ""'>
            <input v-on:change='uploadData' ref='inputFileRelations' type='file' class='file-input' name='file' id='file' :accept="inputAccept" style='cursor: pointer; width: 100%; height: 100%'>
            {{ elements[0].name }}
          </a>
          <a class="panel-block" :class='elements[1].active ? "is-active" : ""' v-on:click='downloadTemplateData'>
            {{ elements[1].name }}
          </a>
          <p class="panel-tabs has-text-centered">
            <span class='has-text-weight-bold'>Comentarios</span>
          </p>
          <a class="panel-block file-label" :class='elements[2].active ? "is-active" : ""'>
            <input v-on:change='uploadComments' ref='inputFileResponses' type='file' class='file-input' name='file' id='file' :accept="inputAccept" style='cursor: pointer; width: 100%; height: 100%'>
            {{ elements[2].name }}
          </a>
          <a class="panel-block" :class='elements[3].active ? "is-active" : ""' v-on:click='downloadComments'>
            {{ elements[3].name }}
          </a>
        </div>
      </nav>
      <download-options-modal
        :active.sync="isDownloadModalActive"
        title="Descargar encuestados"
        all-label="Todos los encuestados"
        all-description="Exporta la lista completa"
        :all-count="employees ? employees.length : 0"
        pending-label="Solo los no finalizados"
        pending-description="Quienes aún no completan la encuesta"
        :pending-count="pendingCount"
        @download-all="downloadUsers('all')"
        @download-pending="downloadUsers('pending')"
      />
    </div>
  `,
  data() {
    return {
      active: false,
      isDownloadModalActive: false,
      elements: [
        {
          name: "Cargar Datos",
          tooltip: "Cargar Excel de datos",
          active: false,
        },
        {
          name: "Descargar Plantilla",
          tooltip: "Descargar plantilla de datos",
          active: false,
        },
        {
          name: "Cargar Comentarios",
          tooltip: "Cargar Excel de comentarios",
          active: false,
        },
        {
          name: "Descargar Comentarios",
          tooltip: "Descargar Excel de todo los comentarios",
          active: false,
        },
      ],
      filesAccept: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ],
      inputAccept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
      form: {
        advanceUpload: 0,
      },
    };
  },
  props: {
    employees: Array,
    proceso: Object,
  },
  computed: {
    ...mapState(["isMovil"]),
    participation: function() {
      if (!this.employees || this.employees.length === 0) return 0;
      const completed = this.employees.filter(function(e) {
        return ["Terminada", "Calculado"].includes(e.status);
      }).length;
      return (completed / this.employees.length) * 100;
    },
    showReminderChip: function() {
      if (this.participation >= 89) return false;
      return !!this.proceso;
    },
    reminder50Sent: function() {
      return this.proceso && !!this.proceso.reminder50SentAt;
    },
    pendingCount: function() {
      if (!this.employees) return 0;
      return this.employees.filter(function(x) {
        return x.status !== "Calculado";
      }).length;
    },
  },
  methods: {
    formatDate: function(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("es-CO", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    async resendReminder50() {
      const self = this;
      const config = {
        title: "¿Reenviar recordatorio?",
        text: "Se enviará el recordatorio del 50% a todos los pendientes nuevamente.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, reenviar",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#de5b5b",
      };
      await this.$swal(config).then(async function(result) {
        if (result.isConfirmed) {
          try {
            const res = await apiServices.post(
              "/sendreminder50clima/" + self.proceso._id
            );
            if (res.data.success) {
              await self.$swal({
                text: "Recordatorio enviado a " + res.data.enviados + " personas.",
                icon: "success",
                showConfirmButton: false,
                timer: 2000,
              });
              self.$emit("refresh");
            } else {
              await self.$swal({
                text: res.data.message || "No se pudo enviar el recordatorio.",
                icon: "warning",
                showConfirmButton: false,
                timer: 1700,
              });
            }
          } catch (err) {
            console.log(err);
            await self.$swal({
              text: "Error al enviar el recordatorio.",
              icon: "error",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        }
      });
    },
    activeMenu() {
      this.active = !this.active;
    },
    uploadData(e) {
      const input = e.target;
      const file = input.files && input.files[0];
      let run;
      if (file) {
        run = runExcelUpload(this, {
          file,
          input,
          proceso: this.proceso._id,
          tipo: "respuestas",
          batchPath: "/saveempleadoslote2",
          refresh: () => this.calculateAll(),
          refreshOnBatchMessage: false,
          loadingBeforeUpload: true,
        });
      }
      this.activeMenu();
      return run;
    },
    uploadComments(e) {
      const _this = this;
      let task;
      const files = e.target.files;
      if (files.length) {
        const file = files[0];
        task = _this.$fire.refexcel(file);
        _this.form.advanceUpload = 10;
        task.on(
          "state_changed",
          (snapshot) => {
            const percentage =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if (percentage > 10) {
              _this.form.advanceUpload = percentage;
            }
          },
          (err) => {
            console.log("error subiendo el archivo", err);
            e.target.files = null;
          },
          async () => {
            try {
              const url = await task.snapshot.ref.getDownloadURL();
              _this.form.advanceUpload = 0;
              const data = {
                url: url,
                proceso: this.proceso._id,
              };
              const result = await apiServices.post(
                `/saveurlcomentariosclima`,
                data,
              );
              if (result.data) {
                e.target.files = null;
                await this.getEmployees();
              }
            } catch (err) {
              console.log("ocurrio un error", err);
              e.target.files = null;
            }
          },
        );
      }
      this.activeMenu();
    },
    async downloadTemplateData() {
      try {
        let result;
        result = await apiServices.post(
          `/downexempleempleados2`,
          { proceso: this.proceso._id },
          { responseType: "blob" },
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `Ejemplo.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
        this.activeMenu();
      } catch (e) {
        console.log(e);
      }
    },
    async downloadComments() {
      try {
        let result;
        result = await apiServices.post(
          `/downcomentariosclima`,
          { proceso: this.proceso._id },
          { responseType: "blob" },
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `Comentarios.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
        this.activeMenu();
      } catch (err) {
        console.log(err);
      }
    },
    async getEmployees() {
      this.$emit("getEmployees");
    },
    async calculateAll() {
      this.$emit("calculateAll");
    },
    async downloadUsers(scope) {
      this.isDownloadModalActive = false;
      try {
        let data = await this.formatData(this.employees, scope);

        if (data.data.length > 0) {
          //  Recorremos las diferentes datas creando un Excel para cada uno
          for (let i = 0; i < data.data.length; i++) {
            //  Asignamos la informacion necesaria a nuevas variables
            let dataExc = data.data[i];
            let name = data.names[i];
            //  Se agrega la data al libro de excel
            const ws = XLSX.utils.json_to_sheet(dataExc);

            //  Se configura el tamaño de cada columna
            const widths = this.widthCols(dataExc);
            ws["!cols"] = widths;

            //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Usuarios pendientes");
            const nombreArchivo = name + ".xlsx";
            XLSX.writeFile(wb, nombreArchivo);
          }
        } else {
          await this.$store.dispatch("notify", {
            message: `No hay datos para descargar`,
            type: "is-link",
          });
        }
      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    },
    async sendAllEmails() {
      const config = {
        title: "¿Estás seguro?",
        text: "Enviaras un correo a todos los empleados pendientes.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#de5b5b",
        confirmButtonText: "Sí, enviar",
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          let result;
          try {
            result = await apiServices.post(`/enviarcorreolote1`, {
              proceso: this.proceso._id,
            });
            if (result.isDenied) {
              await this.$swal({
                text: "Error al enviar todos los correos.",
                icon: "error",
                showConfirmButton: false,
                timer: 1700,
              });
            } else if (result.data) {
              await this.$swal({
                text: "Correo enviados correctamente.",
                icon: "success",
                showConfirmButton: false,
                timer: 1700,
              });
              await this.getEmployees();
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    async switchStatus() {
      const config = {
        title: "¿Estás seguro?",
        text: `Se ${
          this.proceso.survey ? "deshabilitar" : "habilitar"
        } las encuestas para todos los empleados.`,
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#de5b5b",
        confirmButtonText: `Sí, ${
          this.proceso.survey ? "deshabilitar" : "habilitar"
        }`,
      };

      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          let result;
          try {
            result = await apiServices.post("activesurveysclima", {
              idProcess: this.proceso._id,
              newStatus: !this.proceso.survey,
            });

            if (result.data) {
              if (this.proceso) {
                const newData = {
                  ...this.proceso,
                  survey: result.data.survey,
                };
                this.$emit("updateProcess", newData);
              }

              await this.$store.dispatch("notify", {
                message: `Se ha ${
                  !this.proceso.survey ? "habilitado" : "deshabilitado"
                } las encuestas.`,
                type: "is-link",
              });
            }
          } catch (error) {
            console.log(error);
            await this.$store.dispatch("notify", {
              message: `Error al ${
                !this.params.data.status ? "habilitar" : "deshabilitar"
              } las encuestas.`,
              type: "is-danger",
            });
          }
        }
      });
    },
    // Helpers
    async formatData(d, scope) {
      let data = [];
      try {
        d.map((x) => {
          if (scope === "all" || x.status !== "Calculado") {
            let configMailjet = {};

            if (x.mailRecord) {
              const keyMailjet = x.mailRecord.status
                .toLowerCase()
                .replace(" ", "_");
              configMailjet = MAILJET_STATUS_CONFIG[keyMailjet];
            }

            const user = {
              Encuesta: x.status,
              Nombre: x.nombre,
              Cédula: x.cedula,
              Correo: x.email,
              Estado: configMailjet.label || "-",
              "Enlace de la encuesta": `${window.location.host}/encuestaclima/${x._id}`,
            };

            data.push(user);
          }
        });
        return {
          data: [data],
          names: [scope === "all" ? "Todos los encuestados" : "Usuarios sin Calcular"],
        };
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel.`,
          type: "is-danger",
        });
      }
    },
    widthCols(data) {
      let values = [];
      //  Se recorre todos los datos
      for (let i = 0; i < data.length; i++) {
        let cont = 0;
        // Se recorre la informacion de un Dato
        for (const d in data[i]) {
          // Si es la primera iteracion arma el dato con el tamaño del campo y lo guarda la array values
          if (i === 0) {
            let w = { width: String(data[i][d]).length + 2 };
            values.push(w);
          }
          //  Si no es la primera iteracion compara los datos nuevo con los valores del array values
          //  con el fin de extraer el numero mas grande
          else {
            let w = String(data[i][d]).length + 2;
            if (values[cont].width < w) {
              values[cont].width = w;
            }
            cont++;
          }
        }
      }
      // Se valian los tamaños de los titulos para evitar corte de texto en el Excel
      let cont = 0;
      for (const key in data[0]) {
        let w = String(key).length + 2;
        if (values[cont].width < w) {
          values[cont].width = w;
        }
        cont++;
      }

      //  Se devuelve values con el formato necesario para el tamaño de columnas del Excel
      return values;
    },
  },
};
</script>
<style>
.panel-heading {
  display: flex;
  justify-content: space-between;
}

#menuFilter {
  margin-top: 15px !important;
  background: white;
  position: absolute;
  z-index: 250;
  max-height: 360px !important;
}

#menuFilter .panel-body {
  max-height: 300px !important;
  overflow: auto;
}

#menuFilter .panel-block {
  background-color: white;
}

#menuFilter .panel-block:hover {
  background-color: #f5f5f5 !important;
}

#menuFilter .is-active {
  border-left: solid 3px #41aae7;
  color: #363636;
  background: aliceblue;
}

.panel-block .panel-icon .material-icons {
  line-height: unset !important;
}

.buttons {
  margin-bottom: 0;
}

/* Chip de recordatorio 50% */
.reminder-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  margin-right: 12px;
}

.reminder-chip .material-icons {
  font-size: 16px;
}

.reminder-chip.is-pending {
  background: #fff3cd;
  color: #856404;
}

.reminder-chip.is-sent {
  background: #d4edda;
  color: #155724;
}

.reminder-chip .resend-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 2px;
  margin-left: 4px;
  color: inherit;
  display: flex;
  align-items: center;
}

.reminder-chip .resend-btn:hover {
  opacity: 0.7;
}

.reminder-chip .resend-btn .material-icons {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/menuTableSurvey.vue